import 'css-chunksrc/client/pages/planzoneParametersPage/organization/styles.scss';export default {
  "organization": "_organization_1m1ii_1",
  "viewToggle": "_viewToggle_1m1ii_5"
};